import CmpUtils from '@cmp';
import DeviceConfig from '@devices/config';
import FlavourConfig from '../config/flavours';
import Package from '../../package.json';
import ScreenUtils from '@screen';
import Storage from '@storage';
import User from '../classes/user';
import { setToken } from '../store/slices/user.slice';
import { store } from '../store/store';

const ParserUtils = {
  prerollParser(source: string, section?: string, playback = false) {
    try {
      if (!source) return '';

      const { channels, user } = store.getState();
      const plan = User.getPlan(user.planId);

      const { advertisement: planAds } = plan || {};
      const { advertisement: channelAds, isFast } =
        channels.currentChannel || {};

      // Get number of prerolls

      let totalPrerolls = 1;
      if (playback) {
        // FVOD
        if (isFast) {
          const channelPrerolls = channelAds?.adsNumPrerolsFvod?.vod || 1;
          const planPrerolls = planAds?.sections?.adsNumPrerolsFvod?.vod || 1;
          totalPrerolls = Math.min(channelPrerolls, planPrerolls);
        }
        // BVOD
        else {
          let playbackSection = 'restart';
          switch (section) {
            case 'catchup':
            // @ts-ignore
            case 'events':
              playbackSection = 'u7d';
            // @ts-ignore
            case 'recordings':
              playbackSection = 'npvr';
            case 'startOver':
              const channelPrerolls =
                channelAds?.adsNumPrerolsBvod[playbackSection] || 1;
              const planPrerolls =
                planAds?.sections?.adsNumPrerolsBvod[playbackSection] || 1;
              totalPrerolls = Math.min(channelPrerolls, planPrerolls);
              break;
            default:
              break;
          }
        }
      }

      // Replace pod ad slots value with the number of prerolls

      const argument = 'pod_ad_slots=';
      const adSlotPosition = source.indexOf(argument) + argument?.length;
      const nextArgPosition = source.indexOf('&', adSlotPosition);
      source = `${source.substring(
        0,
        adSlotPosition
      )}${totalPrerolls}${source.substring(nextArgPosition, source?.length)}`;
    } catch (error) {
      console.error('[Ad Utils] Get prerolls:', error);
    }
    return source;
  },
  sourceParser(source: string) {
    try {
      const { channels, user } = store.getState();
      const plan = User.getPlan(user.planId);

      const { advertisement: channelAds } = channels.currentChannel || {};
      const { advertisement: planAds } = plan || {};

      // Parameter values

      const { advertisement: deviceAds, info, seller } = DeviceConfig;
      const { ifaId, ifaType, limitAdTracking } = deviceAds;
      const { language, make, model, platform, uuid } = info;
      const { bundleId, storeUrl } = seller;

      const { appName, carrierId } = FlavourConfig;
      const { version } = Package;
      const { height, width } = ScreenUtils;

      const adsMinDuration = (
        channelAds?.adsWindow?.minDuration ||
        planAds?.sections?.adsWindow?.minDuration ||
        ''
      ).toString();
      const adsMaxDuration = (
        channelAds?.adsWindow?.maxDuration ||
        planAds?.sections?.adsWindow?.maxDuration ||
        ''
      ).toString();
      const gdprConsent = CmpUtils.getGDPR();
      const playerHeight = height.toString();
      const playerWidth = width.toString();
      const timestamp = Date.now().toString();
      const userAgent = window?.navigator?.userAgent || info?.userAgent || '';
      const userId = user.token || '';

      // Replace macros

      source = source
        .replace('[adsMaxDuration]', adsMaxDuration)
        .replace('[adsMinDuration]', adsMinDuration)
        .replace('[appName]', appName)
        .replace('[appVersion]', version)
        .replace('[bundleId]', bundleId)
        .replace('[carrier]', carrierId)
        .replace('[deviceId]', uuid)
        .replace('[deviceLanguage]', language)
        .replace('[deviceMake]', make)
        .replace('[deviceModel]', model)
        .replace('[deviceType]', platform)
        .replace('[gdprConsent]', gdprConsent)
        .replace('[ifa]', ifaId)
        .replace('[ifaType]', ifaType)
        .replace('[lmt]', limitAdTracking ? '1' : '0')
        .replace('[playerHeight]', playerHeight)
        .replace('[playerWidth]', playerWidth)
        .replace('[storeUrl]', storeUrl)
        .replace('[timestamp]', timestamp)
        .replace('[tivify_env]', make)
        .replace('[userAgent]', userAgent)
        .replace('[userId]', userId);
    } catch (error) {
      console.error('[Parser Utils] Parse macros:', error);
    }
    return source;
  },
  storageParser() {
    if (FlavourConfig.capabilities.anonymous) {
      Storage.get('first_load') || Storage.set('first_load', '1');
    }

    const userData = localStorage.getItem(`omtv_${FlavourConfig.appName}_user`);
    if (userData) {
      const parsedData = JSON.parse(userData);
      Storage.set('userToken', parsedData.token);
      store.dispatch(setToken(parsedData.token));
      localStorage.removeItem(`omtv_${FlavourConfig.appName}_user`);
    }
  },
};

export default ParserUtils;
